import React, { useState } from 'react';
import './AppPreview.css';

const previews = [
  {
    id: 'dashboard',
    caption: 'Simple dashboard',
    description: 'Ek nazar mein income, expense, balance — sab clear',
  },
  {
    id: 'transaction',
    caption: 'Track every expense',
    description: 'Quick entry — amount, category, done. 10 seconds mein.',
  },
  {
    id: 'reports',
    caption: 'Smart reports',
    description: 'Charts aur graphs se samjho paisa kahan ja raha hai',
  },
  {
    id: 'budget',
    caption: 'Budget planning',
    description: 'Category-wise budget set karo, overspending pe alert pao',
  },
];

const DashboardMockup = () => (
  <div className="app-mockup app-mockup--dashboard">
    <div className="mockup-topbar">
      <span className="mockup-topbar-title">Dashboard</span>
      <div className="mockup-topbar-avatar"></div>
    </div>
    <div className="mockup-cards-row">
      <div className="mockup-stat-card mockup-stat--green">
        <div className="mockup-stat-label">Income</div>
        <div className="mockup-stat-value">&#8377;45,200</div>
      </div>
      <div className="mockup-stat-card mockup-stat--red">
        <div className="mockup-stat-label">Expense</div>
        <div className="mockup-stat-value">&#8377;28,750</div>
      </div>
      <div className="mockup-stat-card mockup-stat--blue">
        <div className="mockup-stat-label">Balance</div>
        <div className="mockup-stat-value">&#8377;16,450</div>
      </div>
    </div>
    <div className="mockup-section-title">Recent Transactions</div>
    <div className="mockup-tx-list">
      <div className="mockup-tx-item">
        <div className="mockup-tx-icon" style={{background: '#fff3e0'}}>&#127828;</div>
        <div className="mockup-tx-info">
          <div className="mockup-tx-name">Groceries</div>
          <div className="mockup-tx-date">Today</div>
        </div>
        <div className="mockup-tx-amount mockup-tx--expense">-&#8377;850</div>
      </div>
      <div className="mockup-tx-item">
        <div className="mockup-tx-icon" style={{background: '#e8f5e9'}}>&#128176;</div>
        <div className="mockup-tx-info">
          <div className="mockup-tx-name">Salary</div>
          <div className="mockup-tx-date">1 Mar</div>
        </div>
        <div className="mockup-tx-amount mockup-tx--income">+&#8377;45,200</div>
      </div>
      <div className="mockup-tx-item">
        <div className="mockup-tx-icon" style={{background: '#e3f2fd'}}>&#128661;</div>
        <div className="mockup-tx-info">
          <div className="mockup-tx-name">Auto Rickshaw</div>
          <div className="mockup-tx-date">Yesterday</div>
        </div>
        <div className="mockup-tx-amount mockup-tx--expense">-&#8377;120</div>
      </div>
    </div>
  </div>
);

const TransactionMockup = () => (
  <div className="app-mockup app-mockup--transaction">
    <div className="mockup-topbar">
      <span className="mockup-topbar-title">Add Transaction</span>
    </div>
    <div className="mockup-form">
      <div className="mockup-form-group">
        <div className="mockup-form-label">Amount</div>
        <div className="mockup-form-input mockup-form-input--amount">&#8377; 1,250</div>
      </div>
      <div className="mockup-form-group">
        <div className="mockup-form-label">Type</div>
        <div className="mockup-form-toggle">
          <span className="mockup-toggle--active">Expense</span>
          <span>Income</span>
        </div>
      </div>
      <div className="mockup-form-group">
        <div className="mockup-form-label">Category</div>
        <div className="mockup-category-grid">
          <span className="mockup-cat mockup-cat--active">&#127828; Food</span>
          <span className="mockup-cat">&#128661; Transport</span>
          <span className="mockup-cat">&#128156; Shopping</span>
          <span className="mockup-cat">&#9889; Bills</span>
          <span className="mockup-cat">&#127968; Rent</span>
          <span className="mockup-cat">&#128138; Medical</span>
        </div>
      </div>
      <div className="mockup-form-group">
        <div className="mockup-form-label">Note</div>
        <div className="mockup-form-input">Lunch at restaurant</div>
      </div>
      <button className="mockup-submit-btn">Save Transaction</button>
    </div>
  </div>
);

const ReportsMockup = () => (
  <div className="app-mockup app-mockup--reports">
    <div className="mockup-topbar">
      <span className="mockup-topbar-title">Reports</span>
    </div>
    <div className="mockup-chart-container">
      <div className="mockup-chart-title">Category Breakdown - March</div>
      <div className="mockup-pie-chart">
        <svg viewBox="0 0 100 100" className="mockup-pie-svg">
          <circle cx="50" cy="50" r="40" fill="transparent" stroke="#27AE60" strokeWidth="20" strokeDasharray="75 175" strokeDashoffset="0" />
          <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3498db" strokeWidth="20" strokeDasharray="50 200" strokeDashoffset="-75" />
          <circle cx="50" cy="50" r="40" fill="transparent" stroke="#e74c3c" strokeWidth="20" strokeDasharray="40 210" strokeDashoffset="-125" />
          <circle cx="50" cy="50" r="40" fill="transparent" stroke="#f39c12" strokeWidth="20" strokeDasharray="35 215" strokeDashoffset="-165" />
          <circle cx="50" cy="50" r="40" fill="transparent" stroke="#9b59b6" strokeWidth="20" strokeDasharray="50 200" strokeDashoffset="-200" />
        </svg>
      </div>
      <div className="mockup-legend">
        <div className="mockup-legend-item"><span style={{background:'#27AE60'}}></span> Food (30%)</div>
        <div className="mockup-legend-item"><span style={{background:'#3498db'}}></span> Transport (20%)</div>
        <div className="mockup-legend-item"><span style={{background:'#e74c3c'}}></span> Shopping (16%)</div>
        <div className="mockup-legend-item"><span style={{background:'#f39c12'}}></span> Bills (14%)</div>
        <div className="mockup-legend-item"><span style={{background:'#9b59b6'}}></span> Other (20%)</div>
      </div>
    </div>
  </div>
);

const BudgetMockup = () => (
  <div className="app-mockup app-mockup--budget">
    <div className="mockup-topbar">
      <span className="mockup-topbar-title">Budgets</span>
    </div>
    <div className="mockup-budget-list">
      <div className="mockup-budget-card">
        <div className="mockup-budget-header">
          <span>&#127828; Food</span>
          <span className="mockup-budget-amount">&#8377;8,500 / &#8377;12,000</span>
        </div>
        <div className="mockup-progress-bar">
          <div className="mockup-progress-fill" style={{width: '71%', background: '#f39c12'}}></div>
        </div>
        <div className="mockup-budget-status" style={{color: '#f39c12'}}>71% used</div>
      </div>
      <div className="mockup-budget-card">
        <div className="mockup-budget-header">
          <span>&#128661; Transport</span>
          <span className="mockup-budget-amount">&#8377;2,100 / &#8377;5,000</span>
        </div>
        <div className="mockup-progress-bar">
          <div className="mockup-progress-fill" style={{width: '42%', background: '#27AE60'}}></div>
        </div>
        <div className="mockup-budget-status" style={{color: '#27AE60'}}>42% used</div>
      </div>
      <div className="mockup-budget-card">
        <div className="mockup-budget-header">
          <span>&#128156; Shopping</span>
          <span className="mockup-budget-amount">&#8377;4,800 / &#8377;5,000</span>
        </div>
        <div className="mockup-progress-bar">
          <div className="mockup-progress-fill" style={{width: '96%', background: '#e74c3c'}}></div>
        </div>
        <div className="mockup-budget-status" style={{color: '#e74c3c'}}>96% used - Almost over!</div>
      </div>
      <div className="mockup-budget-card">
        <div className="mockup-budget-header">
          <span>&#9889; Bills</span>
          <span className="mockup-budget-amount">&#8377;3,200 / &#8377;8,000</span>
        </div>
        <div className="mockup-progress-bar">
          <div className="mockup-progress-fill" style={{width: '40%', background: '#27AE60'}}></div>
        </div>
        <div className="mockup-budget-status" style={{color: '#27AE60'}}>40% used</div>
      </div>
    </div>
  </div>
);

const mockupComponents = {
  dashboard: DashboardMockup,
  transaction: TransactionMockup,
  reports: ReportsMockup,
  budget: BudgetMockup,
};

const AppPreview = () => {
  const [active, setActive] = useState('dashboard');
  const ActiveMockup = mockupComponents[active];

  return (
    <div className="app-preview-section">
      <div className="app-preview-tabs">
        {previews.map((p) => (
          <button
            key={p.id}
            className={`app-preview-tab${active === p.id ? ' app-preview-tab--active' : ''}`}
            onClick={() => setActive(p.id)}
          >
            {p.caption}
          </button>
        ))}
      </div>

      <div className="app-preview-content">
        <div className="app-preview-device">
          <div className="app-preview-device-frame">
            <ActiveMockup />
          </div>
        </div>
        <div className="app-preview-info">
          <h3>{previews.find(p => p.id === active)?.caption}</h3>
          <p>{previews.find(p => p.id === active)?.description}</p>
        </div>
      </div>
    </div>
  );
};

export default AppPreview;
